// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\r\n  background-image: linear-gradient(-110deg, #0f3661, #ff0000);\r\n  margin: 0;\r\n}\r\n\r\nheader {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #2c3e50;\r\n  color: white;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
